<template>
  <div id="app">
    <UpdatePrompt />

    <!-- Login isolado sem layout -->
    <router-view v-if="$route.name === 'login'" />

    <!-- Layout principal com sidebar -->
    <div v-else class="app-layout">
      <div
        v-if="sidebarOpen"
        class="sidebar-overlay"
        @click="sidebarOpen = false"
      ></div>

      <div class="floral-bg" aria-hidden="true">
        <svg
          viewBox="0 0 380 380"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#e8a8a8"
            opacity="0.38"
          />
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#dda0a0"
            opacity="0.34"
            transform="rotate(45 190 190)"
          />
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#e8a8a8"
            opacity="0.36"
            transform="rotate(90 190 190)"
          />
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#dda0a0"
            opacity="0.34"
            transform="rotate(135 190 190)"
          />
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#e8a8a8"
            opacity="0.36"
            transform="rotate(180 190 190)"
          />
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#dda0a0"
            opacity="0.34"
            transform="rotate(225 190 190)"
          />
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#e8a8a8"
            opacity="0.36"
            transform="rotate(270 190 190)"
          />
          <ellipse
            cx="190"
            cy="100"
            rx="20"
            ry="52"
            fill="#dda0a0"
            opacity="0.34"
            transform="rotate(315 190 190)"
          />
          <ellipse
            cx="190"
            cy="128"
            rx="14"
            ry="34"
            fill="#f5c8c8"
            opacity="0.42"
          />
          <ellipse
            cx="190"
            cy="128"
            rx="14"
            ry="34"
            fill="#f5c8c8"
            opacity="0.4"
            transform="rotate(60 190 190)"
          />
          <ellipse
            cx="190"
            cy="128"
            rx="14"
            ry="34"
            fill="#f5c8c8"
            opacity="0.42"
            transform="rotate(120 190 190)"
          />
          <ellipse
            cx="190"
            cy="128"
            rx="14"
            ry="34"
            fill="#f5c8c8"
            opacity="0.4"
            transform="rotate(180 190 190)"
          />
          <ellipse
            cx="190"
            cy="128"
            rx="14"
            ry="34"
            fill="#f5c8c8"
            opacity="0.42"
            transform="rotate(240 190 190)"
          />
          <ellipse
            cx="190"
            cy="128"
            rx="14"
            ry="34"
            fill="#f5c8c8"
            opacity="0.4"
            transform="rotate(300 190 190)"
          />
          <circle cx="190" cy="190" r="36" fill="#c9956c" opacity="0.28" />
          <circle cx="190" cy="190" r="22" fill="#d4a878" opacity="0.32" />
          <circle cx="190" cy="190" r="11" fill="#e8c490" opacity="0.38" />
          <path
            d="M270 55 Q320 88 298 138 Q248 105 270 55Z"
            fill="#5a8860"
            opacity="0.22"
          />
          <path
            d="M300 98 Q344 122 322 172 Q278 148 300 98Z"
            fill="#4a7a50"
            opacity="0.18"
            transform="rotate(12 322 135)"
          />
          <path
            d="M240 35 Q282 58 265 100 Q222 77 240 35Z"
            fill="#6a9870"
            opacity="0.2"
            transform="rotate(-18 255 68)"
          />
          <ellipse
            cx="318"
            cy="68"
            rx="10"
            ry="24"
            fill="#e8a0a0"
            opacity="0.3"
          />
          <ellipse
            cx="318"
            cy="68"
            rx="10"
            ry="24"
            fill="#e0a0a0"
            opacity="0.28"
            transform="rotate(90 318 88)"
          />
          <ellipse
            cx="318"
            cy="68"
            rx="10"
            ry="24"
            fill="#e8a0a0"
            opacity="0.3"
            transform="rotate(60 318 88)"
          />
          <ellipse
            cx="318"
            cy="68"
            rx="10"
            ry="24"
            fill="#e0a0a0"
            opacity="0.28"
            transform="rotate(150 318 88)"
          />
          <circle cx="318" cy="88" r="11" fill="#c9956c" opacity="0.28" />
          <ellipse
            cx="348"
            cy="185"
            rx="8"
            ry="18"
            fill="#e8a8a8"
            opacity="0.24"
          />
          <ellipse
            cx="348"
            cy="185"
            rx="8"
            ry="18"
            fill="#e8a8a8"
            opacity="0.22"
            transform="rotate(70 348 195)"
          />
          <circle cx="348" cy="203" r="9" fill="#c9956c" opacity="0.24" />
        </svg>
      </div>

      <AppSidebar :open="sidebarOpen" />

      <div class="app-main">
        <AppTopBar @toggle="sidebarOpen = !sidebarOpen" />

        <!-- Banner de download do APK (só no browser, não no app nativo) -->
        <div v-if="showApkBanner" class="apk-banner">
          <div class="apk-banner__inner">
            <svg
              class="apk-banner__icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="5" y="2" width="14" height="20" rx="2" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <polyline points="8 12 12 16 16 12" />
            </svg>
            <span class="apk-banner__text">
              Acesse via app no Android para melhor experiência
            </span>
            <a
              :href="apkDownloadUrl"
              download="fina-mabe-erp.apk"
              class="apk-banner__btn"
              @click.stop
            >
              Baixar APK
            </a>
            <button
              class="apk-banner__close"
              aria-label="Fechar"
              @click="dismissApkBanner"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>

        <main class="main-content">
          <!-- Rota na chave: Novo e Editar (pedido/material) usam a mesma
               tela; sem isso, ir de uma para a outra reaproveitava os dados -->
          <router-view
            :key="`${$store.getters.currentCompany?.id}:${$route.matched[0]?.path}`"
          />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import AppSidebar from "@/components/AppSidebar.vue";
import AppTopBar from "@/components/AppTopBar.vue";
import UpdatePrompt from "@/components/UpdatePrompt.vue";
import { isNativeApp } from "@/utils/platform";
import { APK_DOWNLOAD_URL } from "@/config/appVersion";
import { App } from "@capacitor/app";

export default {
  name: "App",
  components: {
    AppSidebar,
    AppTopBar,
    UpdatePrompt,
  },
  data() {
    return {
      sidebarOpen: false,
      apkBannerDismissed: localStorage.getItem("apk-banner-dismissed") === "1",
      apkDownloadUrl: APK_DOWNLOAD_URL,
    };
  },
  computed: {
    showApkBanner() {
      return (
        !isNativeApp() &&
        !this.apkBannerDismissed &&
        this.$store.getters.isAuthenticated
      );
    },
  },
  mounted() {
    if (isNativeApp()) {
      const router = this.$router;
      App.addListener("backButton", ({ canGoBack }) => {
        if (canGoBack) {
          router.back();
        }
        // sem histórico: não faz nada (impede sair do app)
      });
    }
  },
  beforeUnmount() {
    if (isNativeApp()) {
      App.removeAllListeners();
    }
  },
  methods: {
    dismissApkBanner() {
      localStorage.setItem("apk-banner-dismissed", "1");
      this.apkBannerDismissed = true;
    },
  },
};
</script>

<style>
#app {
  font-family: var(--font);
  min-height: 100vh;
}

.app-layout {
  display: flex;
  min-height: 100vh;
}

.floral-bg {
  position: fixed;
  top: -30px;
  right: -30px;
  width: 360px;
  height: 360px;
  pointer-events: none;
  z-index: 0;
  opacity: 0.7;
  filter: blur(1.5px);
}

.floral-bg svg {
  width: 100%;
  height: 100%;
}

.floral-bg ellipse,
.floral-bg circle {
  fill: var(--c-accent);
}

.sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(31, 53, 48, 0.45);
  z-index: 199;
  backdrop-filter: blur(2px);
}

.app-main {
  flex: 1;
  /* item flex cresce até o conteúdo mais largo (ex.: folha de etiquetas):
     sem isso a página inteira alargava no celular */
  min-width: 0;
  margin-left: var(--sidebar-w);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

/* ── Banner APK ───────────────────────────────────── */
.apk-banner {
  background: linear-gradient(90deg, #1a2e2a 0%, #1f3530 100%);
  border-bottom: 1px solid rgba(201, 149, 108, 0.25);
  padding: 0.6rem 1.5rem;
}

.apk-banner__inner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  max-width: 960px;
}

.apk-banner__icon {
  width: 18px;
  height: 18px;
  color: #c9956c;
  flex-shrink: 0;
}

.apk-banner__text {
  flex: 1;
  font-size: 0.875rem;
  color: rgba(240, 232, 222, 0.8);
}

.apk-banner__btn {
  display: inline-flex;
  align-items: center;
  padding: 0.375rem 1rem;
  background: #c9956c;
  color: #fff;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.2s;
}

.apk-banner__btn:hover {
  background: #b07a52;
}

.apk-banner__close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  color: rgba(240, 232, 222, 0.4);
  flex-shrink: 0;
  transition: color 0.2s;
  display: flex;
}

.apk-banner__close svg {
  width: 16px;
  height: 16px;
}

.apk-banner__close:hover {
  color: rgba(240, 232, 222, 0.8);
}

@media (max-width: 640px) {
  .apk-banner {
    padding: 0.6rem 1rem;
  }

  .apk-banner__text {
    font-size: 0.8125rem;
  }
}

@media (max-width: 1023px) {
  .sidebar-overlay {
    display: block;
  }

  .app-main {
    margin-left: 0;
  }

  .floral-bg {
    width: 220px;
    height: 220px;
  }
}
</style>
